import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/base.less'
import './assets/style/reset.less'
import './assets/style/sourceCommon.less'
import App from './App.vue'
import IconSvg from '@/components/common/iconSvg.vue'
import { GetUserAuth, ServiceShareInfo } from 'tvu-common-ui'
import i18n from '@/assets/lang/i18n'

import '@/assets/iconfont/iconfont.js'
import creatWebsocket from '@/assets/js/createWebsocket.js'
import wsSubscriptionPlugin from '@/assets/js/wsSubscriptionPlugin'
import mqttManager from '@/assets/js/mqttManager' // MQTT 编排层单例 [Claude Code]

// 滚动加载
import Scroll from '@/directive/scroll'
import Draggable from '@/directive/drag'
import observeVisibility from '@/directive/observeVisibility'
import authImage from '@/directive/authImage'
import authImg from '@/directive/authImg'
import selectScroll from '@/directive/selectScroll'

import { createAxiosInstance } from '@/axios/index'
import { ContentLoader } from 'vue-content-loader'
import filters from '@/assets/js/filters'
import MHNotify from '@/assets/js/MHNotify'

// import jumpSSOLogin from '@/assets/js/ssoLogin.js'

// 遍历注册全局过滤器
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))
Vue.component('IconSvg', IconSvg)
Vue.component('ContentLoader', ContentLoader)
Vue.use(Scroll)
Vue.use(Draggable)
Vue.use(observeVisibility)
Vue.use(authImage)
Vue.use(authImg)
Vue.use(selectScroll)
Vue.use(creatWebsocket)
Vue.use(wsSubscriptionPlugin)
Vue.prototype.$store = store
Vue.prototype.$mqtt = mqttManager // 全局可用的 MQTT 编排单例 [Claude Code]
Vue.prototype.$getUserAuth = GetUserAuth
Vue.prototype.$tvuServiceShareInfo = ServiceShareInfo
// 可用于common-ui、sourceObject
Vue.prototype.$ajax = createAxiosInstance()
// Vue.use(jumpSSOLogin)
// 供集成的外部js使用
Vue.prototype.$MHNotify = MHNotify
window.JSMessage = MHNotify // 替换原来的 ElementUI.Notification，使用 MHNotify 统一封装 [Claude Code]
window.JSConfirm = ElementUI.MessageBox
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

window.Vue = Vue
window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
